/** Helpers for multi-level iso-surfaces (one mesh per contour level). Pure. */

import { defaultLevelIndices } from './model-colour';

export const ISO_TRIANGLE_CAP = 1500000; // total over all levels

/** Indices of the contour levels drawn: the user's picks (any in range) or every `every`-th (default 3rd). */
export function selectedLevelIndices(count, every = 3, picked = null) {
  if (picked) return picked.filter((i) => i >= 0 && i < count).sort((a, b) => a - b);
  return defaultLevelIndices(count, every);
}

/** Concatenate meshes ({positions, normals, indices, vertexCount, triangleCount}) into one, for export. */
export function mergeMeshes(meshes) {
  const list = meshes.filter(Boolean);
  if (!list.length) return null;
  if (list.length === 1) return list[0];
  const nv = list.reduce((s, m) => s + m.positions.length, 0);
  const ni = list.reduce((s, m) => s + m.indices.length, 0);
  const positions = new Float32Array(nv), normals = new Float32Array(nv), indices = new Uint32Array(ni);
  let pv = 0, pi = 0;
  for (const m of list) {
    positions.set(m.positions, pv); normals.set(m.normals, pv);
    const base = pv / 3;
    for (let i = 0; i < m.indices.length; i++) indices[pi + i] = m.indices[i] + base;
    pv += m.positions.length; pi += m.indices.length;
  }
  return { positions, normals, indices, vertexCount: nv / 3, triangleCount: ni / 3 };
}

/** Keep leading items while the running triangle total stays within `cap`. -> { kept, capped } */
export function capByTriangles(items, cap = ISO_TRIANGLE_CAP) {
  let total = 0;
  const kept = [];
  for (const it of items) {
    const t = it.mesh?.triangleCount || 0;
    if (total + t > cap && kept.length) return { kept, capped: true };
    total += t;
    kept.push(it);
  }
  return { kept, capped: false };
}
